import React from 'react'
import { Link } from 'react-router-dom';
import Bannerbg0 from '../../../assets/images/background/hero1.png';
import Bannerbg from '../../../assets/images/background/hero2.png';
import Slider from 'react-slick';

const Bannerone = () => {
    const Bannerslider = {
        dots: true,
        infinite: true,
        speed: 200,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        fade: true,
        arrows: false,
        slidesToScroll: 1
    }
    return (
        <section className="banner-one">
            <div className="container-fluid p-0">
                <Slider className="banner-one-slider bg-bl" {...Bannerslider}>
                    <div className="banner-one-slider-item">
                        <div className="banner-one-slider-item-image zoom-in">
                            <img
                                src={Bannerbg0}
                                alt="banner-images"
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-7 col-lg-8 col-md-10 ">
                                    <div className="banner-one-info py-6 my-4">
                                        <div className="banner-title fade-left col-lg-5 col-xl-5">
                                            <h1>Trusted NRI solutions <br></br> <span id='anywhere' style={{fontSize: "35px"}}>Anywhere in the world.</span></h1>
                                        </div>
                                        <div className="section-details fade-left">
                                            <p >
                                            We ensure your rights, assets and properties are protected, no matter where you are in the world. And we are here to guide you, with clarity, care, and genuine connection.
                                            </p>
                                        </div>
                                        <div className="fade-in-up">
                                            <Link to="/contact-us" className="btn btn-primary">
                                                Contact us for a Free Consultation
                                                <i className="flaticon-next" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="banner-one-box">
                                    <div className="banner-one-box-inner">
                                        <i className="flaticon-money-bag" />
                                        <h2>5% Interest</h2>
                                    </div>
                                    <p>
                                        Discover our dependable loan solutions designed to empower your
                                        financial journey.
                                    </p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="banner-one-slider-item">
                        <div className="banner-one-slider-item-image zoom-in">
                            <img
                                src={Bannerbg}
                                alt="banner-images"
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-7 col-lg-8 col-md-10">
                                    <div className="banner-one-info">
                                        <div className="banner-title fade-left">
                                            <h1 style={{ lineHeight: "1" }}>
                                                NRI issues resolved <br />
                                                <span
                                                id="anywhere"
                                                style={{
                                                    fontSize: "35px",
                                                    marginTop: "20px",
                                                    display: "block",
                                                    lineHeight: "1.3",
                                                }}
                                                >
                                                With peace of mind and confidence.
                                                </span>
                                            </h1>
                                        </div>

                                        <div className="section-details fade-left">
                                            <p>
                                            Where passion meets expertise, and every client feels like family. Think of us as your full-support solutions arm - because distance shouldn't come in the way of peace of mind.
                                            </p>
                                        </div>
                                        <div className="fade-in-up">
                                            <Link to="/contact-us" className="btn btn-primary">
                                                Contact us for a Free Consultation
                                                <i className="flaticon-next" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="banner-one-box">
                                    <div className="banner-one-box-inner">
                                        <i className="flaticon-money-bag" />
                                        <h2>5% Interest</h2>
                                    </div>
                                    <p>
                                        Discover our dependable loan solutions designed to empower your
                                        financial journey.
                                    </p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </section>
    )
}
export default Bannerone;